<div class="layout-container">
  <app-notifications></app-notifications>
  <div class="side-navbar" *ngIf="showSideNav && sideNavConfig">
    <sync-drawer
      [navItems]="sideNavConfig?.navItems"
      [isExpanded]="sideNavConfig?.isExpanded"
      [hasBackdrop]="sideNavConfig?.hasBackdrop"
      [backdropClick]="sideNavConfig?.backdropClick"
      [closeSideNav]="sideNavConfig?.closeSideNav"
    >
    </sync-drawer>
    <!-- Overlay for side navigation -->
    <div class="overlay" *ngIf="isDrawerExpanded" (click)="onCloseSideNav()"></div>
  </div>

  <div class="content-wrapper" id="filemanager">
    <!-- id=filemanager is required for test script -->
    <sync-app-bar
      *ngIf="!appBarOverride && (!isPreviewLayout || errcode === 9500)"
      class="sync-app-bar"
      [showLeadIcon]="showMenuIcon"
      [leadIcon]="getLeadIconForAppBar()"
      [heading]="useBreadcrumbItems() ? '...' : canGoBack && !showMenuIcon ? '' : fullPageTitle"
      [prominent]="errcode !== 9500 ? true : false"
      [showRightActions]="true"
      [showTrailIcon1]="true"
      [trailIcon1]="{
        iconName: 'help',
        name: 'Help',
        disabled: false,
        size: 'large',
      }"
      [showTrailIcon2]="true"
      [trailIcon2]="{
        iconName: 'lock-encrypted',
        name: 'Secured by Sync',
        disabled: false,
        size: 'large',
      }"
      [showAvatar]="true"
      [avatar]="avtarInfo"
      [onLeadIconClick]="onLeadIconClick"
      [onAvatarClick]="onAvatarClick"
      [onTrailIcon1Click]="onHelpIconClick"
      [onTrailIcon2Click]="$any(showSecuredTooltip)"
      [showBreadcrumb]="useBreadcrumbItems() && !canGoBack && breadcrumbItems.items && breadcrumbItems.items.length > 0"
      [isBreadcrumb]="useBreadcrumbItems() && breadcrumbItems"
      (onBackClick)="onBreadcrumbBackBtn($event)"
      (onMenuItemClick)="onBreadcrumbMenuItem($event)"
      (onItemClicked)="onBreadcrumbClick($event)"
    >
    </sync-app-bar>
    <!-- preview app bar -->
    <sync-app-bar
      *ngIf="
        !appBarOverride &&
        isPreviewLayout &&
        fileType !== previewType.OFFICE_FSV &&
        fileType !== previewType.OFFICE_FSE &&
        errcode !== 9500
      "
      class="sync-app-bar"
      [showLeadIcon]="previewAppbarConfig?.showLeadIcon"
      [leadIcon]="previewAppbarConfig?.leadIcon"
      [heading]="previewAppbarConfig?.heading"
      [prominent]="previewAppbarConfig?.prominent"
      [showRightActions]="previewAppbarConfig?.showRightActions"
      [showTrailIcon1]="previewAppbarConfig?.showTrailIcon1"
      [trailIcon1]="previewAppbarConfig?.trailIcon1"
      [showTrailIcon2]="true"
      [trailIcon2]="{
        iconName: 'lock-encrypted',
        name: 'Secured by Sync',
        disabled: false,
        size: 'large',
      }"
      [showAvatar]="previewAppbarConfig?.showAvatar"
      [avatar]="previewAppbarConfig?.avatar"
      [secondaryTextTemplateRef]="previewAppbarConfig?.secondaryTextTemplate"
      [actionsConfig]="appBarActions || $any({ actions: [] })"
      [onLeadIconClick]="onPreviewBackClick"
      [onAvatarClick]="onAvatarClick"
      [onTrailIcon1Click]="onHelpIconClick"
      [onTrailIcon2Click]="$any(showSecuredTooltip)"
    ></sync-app-bar>
    <!-- history page app bar -->
    <sync-app-bar
      *ngIf="!showMenuIcon && canGoBack"
      class="sync-app-bar"
      [showLeadIcon]="true"
      [leadIcon]="{ iconName: 'arrow-left', disabled: false, size: 'large' }"
      [heading]="fullPageTitle"
      [prominent]="false"
      [showRightActions]="true"
      [onLeadIconClick]="onPreviewBackClick"
    ></sync-app-bar>
    <!-- app bar override -->
    <sync-app-bar
      *ngIf="appBarOverride"
      class="sync-app-bar"
      [showLeadIcon]="appBarOverride?.showLeadIcon"
      [leadIcon]="appBarOverride?.leadIcon"
      [imageUrl]="appBarOverride?.imageUrl"
      [heading]="appBarOverride?.heading ?? pageTitle"
      [prominent]="appBarOverride?.prominent"
      [showRightActions]="appBarOverride?.showRightActions"
      [showTrailIcon1]="appBarOverride?.showTrailIcon1"
      [trailIcon1]="appBarOverride?.trailIcon1"
      [showTrailIcon2]="true"
      [trailIcon2]="{
        iconName: 'lock-encrypted',
        name: 'Secured by Sync',
        disabled: false,
        size: 'large',
      }"
      [showAvatar]="appBarOverride?.showAvatar"
      [avatar]="appBarOverride?.avatar"
      [showSecondaryText]="appBarOverride?.showSecondaryText"
      [secondaryText]="appBarOverride?.secondaryText"
      [ternaryText]="appBarOverride?.ternaryText"
      [actionsConfig]="appBarOverride?.actionsConfig"
      [onLeadIconClick]="appBarOverride?.onLeadIconClick || onLeadIconClick"
      [onAvatarClick]="onAvatarClick"
      [onTrailIcon1Click]="onHelpIconClick"
      [onTrailIcon2Click]="$any(showSecuredTooltip)"
      [showBreadcrumb]="appBarOverride?.showBreadcrumb"
      [isBreadcrumb]="appBarOverride?.isBreadcrumb"
      (onBackClick)="appBarOverride?.onBackClick?.($event)"
    ></sync-app-bar>

    <div #panel class="user-panel" [class.show]="isPanelOpen">
      <app-user-panel (changeStartPage)="openStartPageDialog($event)" (closePanel)="closePanel()"></app-user-panel>
    </div>
    <sync-bottom-sheet #bottomSheetComponent *ngIf="isBottomSheetOpen" type="primary">
      <app-user-panel
        [bottomSheet]="bottomSheetComponent"
        class="user-panel-bottom"
        (changeStartPage)="openStartPageDialog($event)"
      ></app-user-panel>
    </sync-bottom-sheet>
    <!-- Custom layout for certain pages -->
    <div *ngIf="isCustomLayout()">
      <div class="custom-layout">
        <app-global-message class="global-messages" [user]="user" *ngIf="user"></app-global-message>
        <router-outlet></router-outlet>
      </div>
    </div>
    <!-- Default layout for all other pages -->
    <div *ngIf="!isCustomLayout()">
      <div class="page-content">
        <app-global-message class="global-messages" [user]="user" *ngIf="user"></app-global-message>
        <router-outlet></router-outlet>
      </div>
    </div>

    <app-transfer
      *ngIf="transferService.showTransferWindow"
      (openFolder)="handleOpenFolder($event)"
      (previewFile)="handlePreviewFile($event)"
    ></app-transfer>

    <sync-snackbar
      *ngFor="let data of snackbarService?.snackbarData; trackBy: trackByIndex"
      [type]="data?.type"
      [message]="data?.message"
      [config]="data?.config"
      [shouldDismissAfterAction]="data?.shouldDismissAfterAction"
      [leadAdornmentConfig]="data?.leadAdornmentConfig"
      [trailAdornmentConfig]="data?.trailAdornmentConfig"
      [onAction]="$any(data?.trailAdornmentConfig?.buttonConfig?.onClick)"
    ></sync-snackbar>
  </div>
  <div class="help-dialog">
    <app-help-dialog
      [(openHelpDialog)]="openHelpDialog"
      [openContactSupportDialog]="openContactSupportDialog"
    ></app-help-dialog>
  </div>

  <ng-template #secondaryTextTemplate>
    <div class="secondary-text">
      <div class="body-2">{{ this.previewAppbarConfig?.secondaryText }}</div>
      <sync-divider
        *ngIf="isShowDivider && this.previewAppbarConfig?.ternaryText"
        class="action-divider"
        size="large"
      ></sync-divider>
      <div *ngIf="this.previewAppbarConfig?.ternaryText" class="body-2">
        {{ this.previewAppbarConfig?.ternaryText }} <span class="quick-link" [appCopyLink]="fileItem">(copy link)</span>
      </div>
    </div>
  </ng-template>

  <app-process-pill
    *ngIf="processIndicatorService.data"
    [@fadeInOut]
    [text]="processIndicatorService.data.text"
    [completionPercentage]="processIndicatorService.data.completionPercentage"
  ></app-process-pill>

  <div class="change-start-page-dialog">
    <sync-dialog
      [config]="{
        title: 'Change your start page',
        isClosable: true,
        closeIcon: 'close',
        onCloseIcon: closeStartPageDialog,
        actionButton: 'Save',
        cancelButton: 'Cancel',
        isActionButtonDisabled: disableStartPageDialogButtonExecute(),
        onActionClick: onActionStartPageDialogButtonClick,
        onCancelClick: closeStartPageDialog,
      }"
      [open]="showStartPageDialog"
      [onClose]="closeStartPageDialog"
      [hideDialogFooter]="false"
      [isFullScreen]="false"
    >
      <div class="change-start-page-container">
        <div class="title body-2">This will be the page that you always start on whenever you sign in.</div>
        <div class="select-page-warper">
          <div class="select-page-container">
            <div class="current-text body-2">Current:</div>
            <div class="current-selected">
              <sync-icon [name]="startPagesOptions[0].icon" iconSize="small"></sync-icon>
              <div class="body-1 text">
                {{ startPagesOptions[0].name | titlecase }}
              </div>
            </div>
            <div class="divider">
              <sync-divider [text]="'Content'" [size]="'default'"></sync-divider>
            </div>
            <div class="select-text body-2">Choose a new start page:</div>
            <div class="select-page">
              <div
                class="left-button"
                [class.selected]="selectedStartPage === startPagesOptions[1].name"
                (click)="selectedStartPage = startPagesOptions[1].name"
              >
                <div class="left-button-wraper">
                  <sync-icon [name]="startPagesOptions[1].icon" iconSize="small"></sync-icon>
                  <div class="body-1 text">
                    {{ startPagesOptions[1].name | titlecase }}
                  </div>
                </div>
              </div>
              <div
                class="right-button"
                [class.selected]="selectedStartPage === startPagesOptions[2].name"
                (click)="selectedStartPage = startPagesOptions[2].name"
              >
                <div class="right-button-wraper">
                  <sync-icon [name]="startPagesOptions[2].icon" iconSize="small"></sync-icon>
                  <div class="body-1 text">
                    {{ startPagesOptions[2].name | titlecase }}
                  </div>
                </div>
              </div>
            </div>
            <!-- <div></div> -->
          </div>
        </div>
      </div>
    </sync-dialog>
  </div>
</div>
